export default [
  {
    id: 'basic',
    title: '送信先情報',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'rirekisho',
    title: '履歴書',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'keirekisho',
    title: '職務経歴書',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'mail',
    title: '送信メール',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'payment',
    title: '支払い',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'complete',
    title: '完了',
    previewJumpId: 'close-preview-button-above'
  }
]
